import { lazy } from 'react';

import { RoleVariantEnum } from 'common/graphql/types';

export const routes = [
    {
        component: lazy(() => import('module/region/RegionListPage')),
        permissions: [
            'SupportedAwsRegion_Create',
            'SupportedAwsRegion_Edit',
            'SupportedAwsRegion_Delete',
            'SupportedAwsRegion_Read',
        ],
        role: [RoleVariantEnum.SystemAdministrator],
        path: '/',
    },
];
